<template>
    <div class="wishlist-delete-list">
        <p class="wishlist-delete-list__warning">Are you sure you would like to delete {{ selectedWishlistDetails.lname }}?</p>
        <div class="wishlist-delete-list__cta-section">
            <button
                class="btn btn--secondary btn--medium wishlist-delete-list__cta-save"
                @click="handleDeleteList"
                :disabled="isProcessing"
            >
                <span :class="{'wishlist--processing': isProcessing}" class="wishlist__cta-loader">SAVE</span>
            </button>
            <button
                class="btn wishlist-delete-list__cta-cancel" 
                @click="handleCancelClick"
            >
                Cancel
            </button>
        </div>
    </div>
</template>

<script setup>
import { computed, ref, toRefs } from 'vue';
import { useStore } from 'vuex';
import { deleteWishlist } from '../../api';

const props = defineProps({
    onCancel: {
        type: Function,
        default: () => { }
    },

    showWishlistContentPage: {
        type: Function,
        default: () => { }
    },

    selectedWishlistDetails: {
        type: Object,
        default: {}
    }
});

const { selectedWishlistDetails } = toRefs(props);

const store = useStore();

const isProcessing = ref(false);

const handleDeleteList = async () => {
    try {
        isProcessing.value = true;
        const response = await deleteWishlist(selectedWishlistDetails.value.lid);
        if (response) {
            await store.dispatch('fetchWishlistItems');
            handleCancelClick();
            props.showWishlistContentPage(false);
        }
    } catch (error) {
        console.log('Error while deleting', error);
    } finally {
        isProcessing.value = false;
    }
};

const handleCancelClick = () => {
    props.onCancel();
};

</script>
